// extracted by mini-css-extract-plugin
module.exports = {"adWrap":"Z0sMH","adRotateCardDesktop":"_1PdxU","cardDetailText":"_3qVsp"};